import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, EventEmitter, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { PaymentService } from './payment.service';
import { FormControl, Validators } from '@angular/forms';
import gsap from 'gsap';
import { debounceTime, first, Subject, Subscription, switchMap, take, takeUntil, takeWhile, timer } from 'rxjs';
import { AuthService } from '../../../../services/http/auth/auth.service';
import { GameOverlayService } from '../../../../services/game-overlay/game-overlay.service';
import { GameStateService } from '../../../../services/game-state/game-state.service';
import { AudioService } from '../../../../services/audio/audio.service';
import { SignialsService } from '../../../../services/signals/signials.service';
import { GameUiService } from '../../../../services/game-ui/game-ui.service';
import { LoadResoursesService } from '../../../../services/load-resourses/load-resourses.service';
import { GameContext } from '../../../../services/game-ui/game-context.enum';
import { Spine } from '@esotericsoftware/spine-pixi-v8';
import { MetrikaService } from '../../../../services/metrika.service';

export interface Country {
  code: string;
  flag: string;
  name: string;
  mask: string;
  placeholder: string;
}
export interface IPhoto {
  img: string;
  img2: string;
  show: boolean;
  title: string;
  desc:  string;
  rotate: string;
  img2Pos: number;
};

export const countries: Country[] = [
  { code: '+7', flag: '🇷🇺', name: 'Россия', mask: '+7 (###) ###-##-##', placeholder: '+7 (999) 123-45-67' },
  { code: '+7', flag: '🇰🇿', name: 'Казахстан', mask: '+7 (###) ###-##-##', placeholder: '+7 (777) 123-45-67' },
  { code: '+375', flag: '🇧🇾', name: 'Беларусь', mask: '+375 (##) ###-##-##', placeholder: '+375 (29) 123-45-67' },
  { code: '+380', flag: '🇺🇦', name: 'Украина', mask: '+380 (##) ###-##-##', placeholder: '+380 (50) 123-45-67' },
  { code: '+998', flag: '🇺🇿', name: 'Узбекистан', mask: '+998 (##) ###-##-##', placeholder: '+998 (90) 123-45-67' },
];
@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrl: './payment.component.scss',
  providers: [PaymentService, AuthService],
})
export class PaymentComponent implements OnDestroy, AfterViewInit {
	@Output()
	closeModal: EventEmitter<void> = new EventEmitter();
	@Output()
	showPhrase: EventEmitter<string> = new EventEmitter();

  currentPhoto = 0;

  maxPhotos = 7;

  currentStep: number | null = 2;

  paymentType: 1 | 2;

  loading = false;

  email = new FormControl("", [Validators.email, Validators.required]);
  code = new FormControl("");
  phone = new FormControl('');

  hasError = false;
  hasErrorCode = false;
  errorText = '';
  showNote = false;

  subs: Subscription;
  btns: Subscription;
  sounds = ['foto1',
    'foto2',
    'foto3',
    'foto4',
    'foto5',
    'foto6',
    'foto7',
  ];

  photos: IPhoto[] = [{
    img: '1',
    img2: '1',
    show: true,
    title: 'Мифы древней греции',
    desc: 'Разберись с мифами о профессиях — и узнай правду',
    rotate: '-6',
    img2Pos: 70
  }, {
    img: '2',
    img2: '2',
    show: false,
    title: 'Скалодром',
    desc: 'Пойми, что помогает тебе достигать целей и не сдаваться',
    rotate: '5',
    img2Pos: 20
  }, {
    img: '3',
    img2: '3',
    show: false,
    title: 'Дартс',
    desc: 'Выбери сферу, которая тебе действительно интересна',
    rotate: '-6',
    img2Pos: 50
  }, {
    img: '4',
    img2: '4',
    show: false,
    title: 'Угадай профессию',
    desc: 'Проверь, насколько хорошо ты знаешь разные профессии',
    rotate: '6',
    img2Pos: 20
  }, {
    img: '5',
    img2: '5',
    show: false,
    title: 'Стрельба из лука',
    desc: 'Выбери профессию, которая тебе ближе всего',
    rotate: '4',
    img2Pos: 25
  }, {
    img: '6',
    img2: '6',
    show: false,
    title: 'Микс Дартс',
    desc: 'Соедини свои интересы и получи новые неожиданные профессии',
    rotate: '-5',
    img2Pos: 30
  },{
    img: '7',
    img2: '7',
    show: false,
    title: 'Перетягивание каната',
    desc: 'Научись отвечать тем, кто сомневается в твоём выборе',
    rotate: '7',
    img2Pos: 25
  },];
  timeout;
  s;

  showDialog = false;
  showPaymentForm = false;
  showLoader = false;
  showSuccessPayment= false;

  authType = 'email';

  
  get isSendCodeDisabled(): boolean {
    if (this.authType === 'phone') {
      const phoneValue = this.phone.value?.replace(/\D/g, '') || '';
      // Минимум 11 цифр для России/Казахстана (код + 10 цифр)
      return phoneValue.length < 11;
    } else {
      return !this.email.valid;
    }
  }
  resendTimer = 60;
  resendInterval: any;
  acceptTerms = false;

  isWaiting = false;
  
  isOtpMode = false;
  requestId;
  private destroy$ = new Subject<void>();
  constructor(private overlay: GameOverlayService,
    private service: PaymentService,
    private state: GameStateService,
    private cdr: ChangeDetectorRef,
    private audio: AudioService,
    private signal: SignialsService,
    private ui: GameUiService,
    private loadService: LoadResoursesService,
    private metrika: MetrikaService
  ) {
    this.btns = this.ui.skipClicked$.pipe(debounceTime(300)).subscribe(() => {

      if (this.timeout) clearTimeout(this.timeout);
      if (this.currentStep === 1) {
        this.currentStep = 2;
        this.audio.stop(this.sounds[this.currentPhoto]);
        cdr.detectChanges();
      }
      else if (this.currentStep === null) this.startFullGame();
      else this.closeModal.emit();
    });
    this.ui.setContext(GameContext.Payment);
  }
  ngAfterViewInit(): void {
    // this.audio.play(this.sounds[this.currentPhoto]);
    // this.startSound();
    
    this.currentStep = 2;
    this.showDialog=false;

  }
  ngOnDestroy(): void {
    this.subs?.unsubscribe();
    this.s?.unsubscribe();
    this.btns?.unsubscribe();
    this.destroy$.next();
    this.destroy$.complete();
    setTimeout(() => {
      this.closeKeyboard();
    }, 100);
  }
  closeKeyboard(): void {
    const activeElement = document.activeElement;

    if (
      activeElement instanceof HTMLInputElement ||
      activeElement instanceof HTMLTextAreaElement
    ) {
      activeElement.blur();
    }
  }
  onPhoneInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    let value = input.value;
    
    // Оставляем только цифры и плюс в начале
    let digits = value.replace(/[^\d+]/g, '');
    
    // Если плюс не в начале — убираем все плюсы
    if (!digits.startsWith('+')) {
      digits = '+' + digits.replace(/\+/g, '');
    } else {
      digits = '+' + digits.slice(1).replace(/\+/g, '');
    }
    
    // Определяем страну по коду
    const country = this.detectCountry(digits);
    
    // Форматируем по маске
    // const formatted = this.formatByMask(digits, country.mask);
    
    this.phone.setValue(digits, { emitEvent: false });
  }
  private detectCountry(phone: string): Country {
    // Сортируем по длине кода (от длинного к короткому) для корректного определения
    const sortedCountries = [...countries].sort((a, b) => 
      b.code.length - a.code.length
    );
    
    for (const country of sortedCountries) {
      if (phone.startsWith(country.code)) {
        return country;
      }
    }
    
    // По умолчанию Россия
    return countries[0];
  }
  private formatByMask(phone: string, mask: string): string {
    const digits = phone.replace(/\D/g, '');
    let result = '';
    let digitIndex = 0;
    
    for (let i = 0; i < mask.length && digitIndex < digits.length; i++) {
      if (mask[i] === '#') {
        result += digits[digitIndex];
        digitIndex++;
      } else {
        result += mask[i];
      }
    }
    
    return result;
  }

  // Получение полного номера для отправки
  getFullPhone(): string {
    return this.phone.value?.replace(/\D/g, '') || '';
  }

  // Маскировка телефона для отображения
  getMaskedPhone(): string {
    const phone = this.phone.value || '';
    // +7 (999) ***-**-67
    if (phone.length > 8) {
      return phone.slice(0, 7) + '***-**' + phone.slice(-2);
    }
    return phone;
  }
  playHover() {
    this.audio.playTicketHover();
  }

  startSound() {
    // this.audio.stop(this.sounds[this.currentPhoto-1]);
    this.audio.playPolaroid();
    this.audio.playVoice(this.sounds[this.currentPhoto], undefined);
  }

  selectTicket(paymentType) {
    this.metrika.reachGoal('ticket_select', {ticket: paymentType});
    this.paymentType = paymentType;
    this.currentStep = 3;
    this.cdr.detectChanges();
    
    // this.startFullGame();
    // return;
  }

	closed() {
    this.currentPhoto = 0;
    this.currentStep = 1;
		this.closeModal.emit();
    this.overlay.hideOverlay(true);
    this.cdr.detectChanges();
	}
  sendCode() {
    this.hasError = false;
    this.errorText = '';
    
    if (this.loading) return;

    // Валидация в зависимости от типа авторизации
    if (this.authType === 'email') {
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      
      if (!this.email.value) {
        this.hasError = true;
        this.errorText = 'Поле обязательно для заполнения';
        this.cdr.detectChanges();
        return;
      } else if (!emailRegex.test(this.email.value)) {
        this.hasError = true;
        this.errorText = 'Проверьте правильность написания E-mail';
        this.cdr.detectChanges();
        return;
      }
    } else {
      const phoneDigits = this.phone.value?.replace(/\D/g, '') || '';
      
      if (!this.phone.value) {
        this.hasError = true;
        this.errorText = 'Поле обязательно для заполнения';
        this.cdr.detectChanges();
        return;
      } else if (phoneDigits.length < 11) {
        this.hasError = true;
        this.errorText = 'Проверьте правильность написания номера телефона';
        this.cdr.detectChanges();
        return;
      }
    }

    // Блокируем поле и показываем загрузку
    if (this.authType === 'email') {
      this.email.disable();
    } else {
      this.phone.disable();
    }

    this.loading = true;
    this.cdr.detectChanges();

    // Формируем данные для отправки
      const payload = this.authType === 'email'
      ? { type: 'email', value: this.email.value }
      : { phone: this.phone.value?.replace(/\D/g, '') };

    if (this.authType === 'email')
    this.service.sendCode(payload).subscribe({
      next: () => {
        if (!this.resendInterval)
          this.resendInterval = setInterval(() => {
            this.resendTimer--;
            if (this.resendTimer === 0) {
              clearInterval(this.resendInterval);
              this.resendInterval = null;
            }
            this.cdr.detectChanges();
          }, 1000);
        this.hasError = false;
        this.errorText = '';
        this.currentStep = 4;
        this.loading = false;
        this.cdr.detectChanges();
      },
      error: () => {
        this.hasError = true;
        this.errorText = 'Произошла непредвиденная ошибка. Попробуйте позже';
        this.loading = false;
        // Разблокируем поле при ошибке
        if (this.authType === 'email') {
          this.email.enable();
        } else {
          this.phone.enable();
        }
        this.cdr.detectChanges();
      }
    });
    else
      this.service.sendPhoneCode(payload).subscribe({
      next: (data) => {
        this.isWaiting = true;
        this.checkMobileAuthStatus(data['request_id']);
      },
      error: () => {
        this.hasError = true;
        this.errorText = 'Произошла непредвиденная ошибка. Попробуйте позже';
        this.loading = false;
        // Разблокируем поле при ошибке
        if (this.authType === 'email') {
          this.email.enable();
        } else {
          this.phone.enable();
        }
        this.cdr.detectChanges();
      }
    });
  }

  private checkMobileAuthStatus(requestId: number): void {
    timer(0, 2500)
      .pipe(
        takeUntil(this.destroy$),
        takeWhile(() => !this.isOtpMode),
        switchMap(() =>
          this.service.getMobileAuthStatus(requestId)
        ),
        takeWhile(
          response => response.status === 'pending' || response.status === 'needs_otp',
          true
        )
      )
      .subscribe({
        next: (response) => {
          switch (response.status) {
            case 'pending':
              // ничего не делаем, polling продолжится
              break;

            case 'success':
              this.isWaiting = false;
              this.hasError = false;
              this.errorText = '';
              this.loading = false;
              this.currentStep = 5;

              localStorage.setItem('token', `${response.token?.token_type} ${response.token?.access_token}`);
              this.createOrder(response.token?.access_token);
              break;

            case 'needs_otp':
              // Показываем OTP поле, но polling продолжается —
              // если пользователь подтвердит SIM-PUSH, следующий poll вернёт success
              if (!this.isOtpMode) {

              if (!this.resendInterval)
                this.resendInterval = setInterval(() => {
                  this.resendTimer--;
                  if (this.resendTimer === 0) {
                    clearInterval(this.resendInterval);
                    this.resendInterval = null;
                  }
                  this.cdr.detectChanges();
                }, 1000);
                this.isWaiting = false;
                this.hasError = false;
                this.errorText = '';
                this.currentStep = 4;
                this.loading = false;
                this.isOtpMode = true;
                this.requestId = requestId;
              }
              break;

            case 'failed':
              this.isWaiting = false;
              this.hasError = true;
              
              this.loading = false;

              this.errorText =
                response.message || 'Не удалось выполнить вход';

              this.phone.enable();
              break;
          }

          this.cdr.detectChanges();
        },

        error: () => {
          this.isWaiting = false;
          this.hasError = true;
          this.errorText =
            'Произошла ошибка при проверке авторизации';

          this.phone.enable();

          this.cdr.detectChanges();
        }
      });
  }

  sendCodeAgain() {
    this.resendTimer = 60;
    if (!this.resendInterval)
      this.resendInterval = setInterval(() => {
        this.resendTimer--;
        if (this.resendTimer === 0) {
          clearInterval(this.resendInterval);
          this.resendInterval = null;
        }
        this.cdr.detectChanges();
      }, 1000);
    this.loading = true;
    this.hasError = false;
    this.showNote = true;
    this.errorText = '';
    
    // Формируем данные для отправки
    const payload = this.authType === 'email'
    ? { type: 'email', value: this.email.value }
    : { phone: this.phone.value?.replace(/\D/g, '') };
    if (this.authType === 'email')
    this.service.sendCode(payload).subscribe({
      next: () => {
        this.hasError = false;
        this.errorText = '';
        
        this.loading = false;
        this.cdr.detectChanges();
      },
      error: () => {
        this.hasError = true;
        this.errorText = 'Произошла непредвиденная ошибка. Попробуйте позже';
        this.loading = false;
        this.cdr.detectChanges();
      }
    });
    else {
      this.isOtpMode = false;
      // this.destroy$.next();
      this.service.sendPhoneCode(payload).subscribe({
      next: (data) => {
        this.isWaiting = true;
        this.checkMobileAuthStatus(data['request_id']);
      },
      error: () => {
        this.hasError = true;
        this.errorText = 'Произошла непредвиденная ошибка. Попробуйте позже';
        this.loading = false;
        // Разблокируем поле при ошибке
        if (this.authType === 'email') {
          this.email.enable();
        } else {
          this.phone.enable();
        }
        this.cdr.detectChanges();
      }
    });
    }
  }

	confirm(isOtpMode: boolean) {
    if (this.loading) return;
    this.hasError = false;
    this.hasErrorCode = false;
    this.errorText = '';
    if (!this.code.value) {
      this.hasErrorCode = true;
      this.errorText = 'Поле обязательно для заполнения';
      return;
    }
    this.loading = true;
    
    this.ui.setContext(GameContext.PaymentWait);
    if (isOtpMode) {
      this.service.verifyOtp({request_id: this.requestId, code: this.code.value}).subscribe({
        next: (data: any) => {
          this.hasError = false;
          
          this.errorText = '';
          this.loading = false;
          this.currentStep = 5;
          localStorage.setItem('token', `${data.token.token_type} ${data.token.access_token}`);
          if (!data.has_paid) this.createOrder(data.token.access_token);
          else {
            this.ui.setContext(GameContext.PaymentWait);
            this.showPaymentForm = false;
            this.metrika.reachGoal('payment_success', {ticket: this.paymentType});
            this.showSuccessPayment = true;
            this.cdr.detectChanges();
          }
        },
        error: () => {
          this.loading = false;
          this.hasErrorCode = true;
          this.errorText = 'Введен не верный код подтверждения';
          this.cdr.detectChanges();
        }
      });
    } else
		this.service.verifyMail(this.code.value).subscribe({
      next: (data: any) => {
        this.hasError = false;
        this.errorText = '';
        this.loading = false;
        this.currentStep = 5;
        localStorage.setItem('token', `${data.token.original.token_type} ${data.token.original.access_token}`);
        if (!data.has_paid) this.createOrder(data.token.original.access_token);
        else {
          this.ui.setContext(GameContext.PaymentWait);
          this.showPaymentForm = false;
          this.metrika.reachGoal('payment_success', {ticket: this.paymentType});
          this.showSuccessPayment = true;
          this.cdr.detectChanges();
        }
      },
      error: () => {
        this.loading = false;
        this.hasErrorCode = true;
        this.errorText = 'Введен не верный код подтверждения';
        this.cdr.detectChanges();
      }
    });

	}

  openPolicy() {
    window.open('https://careerpark.ru/policy', '_blank', 'noopener,noreferrer');
  }
  openAgreement() {
    window.open('https://careerpark.ru/terms', '_blank', 'noopener,noreferrer');
  }
	createOrder(token) {
		const hash = localStorage.getItem('hash');
		this.service.createOrder(hash!, token, this.paymentType).subscribe(data  => {
      this.showPaymentForm = true;

      const checkout = new window['YooMoneyCheckoutWidget']({
        confirmation_token: data.confirmation_token, //Токен, который перед проведением оплаты нужно получить от ЮKassa
        error_callback: function(error) {
        }
      });

		  //Отображение платежной формы в контейнере
			setTimeout(() => {
				checkout.render('payment-form');
        this.cdr.detectChanges();
			}, 100);

      checkout.on('success', () => {
        this.ui.setContext(GameContext.PaymentWait);
        this.showPaymentForm = false;
        this.metrika.reachGoal('payment_success', {ticket: this.paymentType});
        this.showSuccessPayment = true;
        this.cdr.detectChanges();
      });
		})
	}
  showFinishPhrase() {
    this.showSuccessPayment = false;

    this.cdr.detectChanges();
    this.s = this.signal.dialogEnded.pipe(take(1)).subscribe(() => {
      this.showLoader = true;
      this.cdr.detectChanges();
      this.loadService.loadAdditionalResources()
        .then(() => {
          this.metrika.reachGoal('paid_part_start');
          this.showLoader = false;
          this.cdr.detectChanges();
          this.startFullGame();
          // console.log('Дополнительные ресурсы загружены');
        })
        .catch(error => {
          console.warn('Ошибка загрузки дополнительных ресурсов:', error);
          this.loadService.retryLoading().then(() => {
          this.startFullGame();
            this.cdr.detectChanges();
          }).catch(() =>   alert('Ошибка загрузки! Попробуйте перезагрузить страницу'));
        });
    });
    this.showPhrase.emit('end');
  }
  prevStep() {
    this.resendInterval && clearInterval(this.resendInterval);
    this.resendInterval = null;
    this.resendTimer = 60;
    this.hasError = false;
    this.errorText = '';
    this.currentStep = 3;
    this.isOtpMode = false;
    this.code.reset();
    this.phone.enable();
    this.email.enable();
    this.cdr.detectChanges();
  }

  startFullGame() {
    const barrier = this.state.resourses.getSpine('barrier1');
    (barrier as Spine)?.state.setAnimation(0, 'Barrier_open_action', false);
    this.audio.playBarrier();
    const eddy = this.state.resourses.getSpine('eddy');

    gsap.to(eddy!, {
      pixi:{
        alpha: 0,
      },
      duration: 1,
      ease: 'none',
    }).then(() => {
      this.state.signal.startTherdEddy.next(true);
    });

    this.state.changeGameStatus('paymentType', this.paymentType);
    this.state.changeGameStatus('completedLocation', 1);

    this.state.path.collectAllPathPoints();
    this.closed();
    this.cdr.detectChanges();
  }

  switchAuthType(type) {
    this.authType = type;
  }
}
